import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserContext } from '../Pages/UserContext';

export const SearchBar = ({ onClose }) => {
  const { search, setSearch } = useContext(UserContext);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onClose();
    navigate('/catalog', { replace: true });
  };

  return (
    <div className="absolute z-40 md:z-0 top-4 -right-3 md:right-72 table:static">
      <form action="search" className="flex gap-4 justify-between" onSubmit={handleSubmit}>
        <input
          type="text"
          className="flex gap-2 table:gap-4 w-44 table:w-48 xl:w-80 h-10 bg-transparent items-center border-2 border-borderColor rounded-2xl px-5 font-poppins font-normal text-base md:text-lg text-font placeholder:text-font placeholder:font-poppins placeholder:text-base md:placeholder:text-lg"
          placeholder="Find your wish"
          autoComplete="off"
          value={search}
          onChange={handleChange}
        />
        <button
          type="submit"
          className="p-1 rounded-full h-10 w-20 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border border-transparent text-font hover:bg-none hover:bg-font hover:text-borderColor duration-300"
          onClick={handleSubmit}>
          Revelio
        </button>
      </form>
    </div>
  );
};
